import React from 'react';
import { ImThemeProvider, ImThemeProviderZenith } from '@im/im-theme';
import { MuiProviders } from '@im/ui-lib/theme/MuiProviders';
import { XvAppId } from '@im/ui-lib/mf-utils';
import { useSiteConfig } from '../../config';

type ThemeProviderProps = {
  children: React.ReactNode;
};

function X4CThemeProvider(props: Readonly<ThemeProviderProps>) {
  const { children } = props;
  return (
    <ImThemeProvider>
      <MuiProviders>{children}</MuiProviders>
    </ImThemeProvider>
  );
}

function X4ECThemeProvider(props: Readonly<ThemeProviderProps>) {
  const { children } = props;

  const { storefrontInfo } = useSiteConfig();

  return (
    <ImThemeProviderZenith themeName={storefrontInfo?.colorScheme}>
      <MuiProviders>{children}</MuiProviders>
    </ImThemeProviderZenith>
  );
}

const providerMap: { [appName: string]: React.FC<ThemeProviderProps> } = {
  cep: X4CThemeProvider,
  x4ec: X4ECThemeProvider,
};

export function ThemeProvider(
  props: Readonly<ThemeProviderProps & { appId: XvAppId }>
) {
  const { appId, children } = props;

  const Provider = providerMap[appId];

  return <Provider>{children}</Provider>;
}
